/// <reference path="hero.HeroMediaBase.js" />
/*
 * PDP hero wrapper for video/iframe elements
 */
var VideoHero = (function () {
    var videoHero = function ($container, $mediaElement) {
        /// <summary>
        /// Constructor for VideoHero objects
        /// </summary>
        /// <param name="$container" type="JQueryObject">The jquery wrapper of the hero image container div</param>
        /// <param name="$mediaElement" type="JQueryObject">The jquery wrapper of the hero image/iframe element</param>
        var that = this;

        HeroMediaBase.call(that, $container, $mediaElement);
        that.displayUtilities = false;
        that.$alternateImage.addClass('pdp-alt-video')
            .attr('data-track', 'aiv-' + that.$mediaElement.data('videotitle'));
        that.$alternateImage
            .children('img').attr('src', that.$mediaElement.data('alternateimage-url'))
            .before('<span class="video-icon-overlay"><span class="icon-play pdp-alt-video-icon"></span></span>');
    };

    videoHero.prototype = Object.create(HeroMediaBase.prototype);
    videoHero.prototype.constructor = videoHero;

    function buildVideoUrl(source, key) {
        /// <summary>
        /// Helper method that returns the full video url for the given source and key
        /// </summary>
        /// <param name="source" type="String">The video's source/host</param>
        /// <param name="key" type="String">The video's unique key/identifier</param>

        switch (source.toLowerCase()) {
            case 'vimeo':
                return 'https://player.vimeo.com/video/' + key + '?autoplay=0&title=0&byline=0&portrait=0';
            case 'youtube':
                return 'https://www.youtube.com/embed/' + key + '?rel=0&amp;showinfo=0&autoplay=0';
            default:
                console.error("The video source " + videoSource + " is not valid");
                return '';
        }
    }

    videoHero.prototype.select = function () {
        var that = this;
        HeroMediaBase.prototype.select.call(that);

        var videoUrl = buildVideoUrl(that.$mediaElement.data('source'), that.$mediaElement.data('key'));
        that.$mediaElement.attr('src', videoUrl);
    };

    return videoHero;
}());